/* 
    Convert a string to dot notation.
	Returns empty string if not found.
*/
/**
 *
 * @param {Object} scope - The base object that the nested objects are part of
 * @param {string} str - A 'dot notation' string like 'aaa.bbb.ccc' that is expected to exist on the 'scope'
 * @returns The value of the object looked up from scope.str
 * @example
 * // scope is window
 * // str is 'aaa.bbb'
 * // window.aaa.bbb is:
 * window: {
 *     aaa: {
 *         bbb: 'ccc'
 *     }
 * }
 * // the function will return 'ccc'
 */
const getDotNotationFromString = (scope, str) =>
	str
		.split('.')
		.reduce((o, x) => (typeof o !== 'undefined' ? o[x] : undefined), scope);

export default getDotNotationFromString;
